import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  ArrowRightOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  ExclamationCircleFilled,
} from '@ant-design/icons';
import './channel_notification.css';
import {
  setJiraNotifConfig,
  getJiraNotifConfig,
  getAllJiraConfigs,
  deleteJiraConfig,
  getJiraProjectStatues,
  dropDownSearchJiraProjects,
} from '../skills_action';
import IssueCardCustomizationInfo from './IssueCardCustomization/IssueCardFieldCustomizationInfo';
import {
  Checkbox,
  Button,
  Select,
  Input,
  message,
  Alert,
  Row,
  Col,
  Spin,
  Tooltip,
  Collapse,
  Divider,
  Modal,
} from 'antd';
import { Typography } from 'antd';
import queryString from 'query-string';
import axios from 'axios';
const { Text, Title } = Typography;
const { Option } = Select;
const { Panel } = Collapse;
const { TextArea } = Input;

// ["comment_created",
// "comment_updated",
// "jira:issue_updated",
// "jira:issue_created",sprint_updated]

const notifEvent = [
  {
    label: 'An issue is created',
    value: 'jira:issue_created',
  },
  {
    label: 'An issue is edited',
    value: 'jira:issue_updated',
  },
  {
    label: 'A comment is added',
    value: 'comment_created',
  },
  {
    label: 'A comment is updated',
    value: 'comment_updated',
  },

  // {
  //   label: "Assignee is changed",
  //   value: "assignee_changed"
  // },

  // {
  //   label: "Priority is updated",
  //   value: "priority_updated"
  // },

  {
    label: 'Sprint started/closed',
    value: 'sprint_updated',
  },
  // {
  //   label: "An issue is transitioned",
  //   value: "issue_transitioned"
  // }
];

let ChannelFrequency = [
  {
    name: 'Real Time',
    value: 0,
  },
  {
    name: '1 min',
    value: 1,
  },
  {
    name: '5 min',
    value: 5,
  },
  {
    name: '15 min',
    value: 15,
  },
  {
    name: '30 min',
    value: 30,
  },
  {
    name: '1 hr',
    value: 60,
  },
  {
    name: '2 hrs',
    value: 120,
  },
  {
    name: '4 hrs',
    value: 240,
  },
  {
    name: '6 hrs',
    value: 360,
  },
  {
    name: '12 hrs',
    value: 720,
  },
];

class JiraChannelNotification extends Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.state = {
      showChannelNotification: false,
      notifStatus: false,
      selectedChannel: this.props.channel_id,
      projectNotif: [],
      notifEvent: [],
      notifFrequency: '',
      edit: false,
      jqlstatus: false,
      jql: '',
      showAddInputs: false,
      addInputs: [],
      error: {},
      selectedChannelName: '',
      selectedProjectName: [],
      fieldsFilterValues: [],
      fieldsFilter: [],
      fields: [],
      // channelNotifFreq:["1 min","2 min"],
      channelNotifFreq: 0,
      projectId: [],
      loading: false,
      showloader: true,
      selectedEvents: [],
      sendAsThreadedMessage: false,
      startThreadSync: true,
      isSubscriptionSaveButtonDisabled: false,
      showIssueCardCustomizationModal: false,
    };
  }

  componentDidMount() {
    // console.log("====componnetdidmount",this.props.projectId);

    this.setState({
      parsedQueryString: queryString.parse(window.location.search),
    });

    let projId;
    if (this.props.projectId) {
      projId = this.props.projectId;
    } else {
      projId = '';
    }
    axios
      .get(
        `/bot/api/w/${this.props.match.params.wId}/jira/${this.props.match.params.skill_id}/user/${this.props.user_now._id}/field`
      )
      .then((res) => {
        if (res && res.data && res.data.success)
          this.setState({ fields: res.data.items, showloader: false });
      });

    if (this.props.configureId) {
      this.props
        .getJiraNotifConfig(
          this.props.match.params.wId,
          this.props.channelId,
          this.props.match.params.skill_id,
          projId,
          this.props.isGridSharedChannel,
          this.props.configureId
        )
        .then((res) => {
          // console.log("====componnetdi",res);
          if (res.data.success) {
            let fieldsFilter = res.data.data.fieldsFilter
              ? res.data.data.fieldsFilter.map((f) => f.id)
              : [];
            let showAddInputs =
              res.data &&
              res.data.data &&
              res.data.data.project_id &&
              res.data.data.event_type.includes('jira:issue_updated') &&
              (!res.data.data.fieldsFilter ||
                res.data.data.fieldsFilter.length === 0 ||
                fieldsFilter.includes('status'))
                ? true
                : false;

            this.setState({
              notifStatus: res.data.data.status,
              projectNotif: res.data.data.project_id,
              jql: res.data.data.jqlQuery,
              notifEvent: res.data.data.event_type,
              selectedEvents: res.data.data.event_type,
              fieldsFilter: res.data.data.fieldsFilter || [],
              fieldsFilterValues: fieldsFilter,
              notifFrequency: res.data.data.frequency,
              selectedProjectName: res.data.data.project_name,
              channelNotifFreq: res.data.data.frequency,
              addInputs: res.data.data.jiratransitions || [],
              showAddInputs,
              showloader: false,
              sendAsThreadedMessage: res.data.data.sendAsThreadedMessage,
              startThreadSync: res.data.data.startThreadSync,
            });
            if (showAddInputs) {
              let project_id =
                typeof res.data.data.project_id == 'string'
                  ? res.data.data.project_id
                  : res.data.data.project_id[0];
              this.props.getJiraProjectStatues(
                this.props.match.params.wId,
                this.props.match.params.skill_id,
                project_id
              );
            }
          }
        });
    } else {
      this.setState({
        notifStatus: true,
        projectNotif: [],
        jql: '',
        notifEvent: [
          'comment_created',
          'comment_updated',
          'jira:issue_updated',
          'jira:issue_created',
          'sprint_updated',
        ],
        selectedEvents: [
          'comment_created',
          'comment_updated',
          'jira:issue_updated',
          'jira:issue_created',
          'sprint_updated',
        ],
        notifFrequency: '',
        // showAddInputs:true,
        selectedProjectName: [],
        channelNotifFreq: 0,
      });
    }
  }
  onjiraFieldChange = (val, field) => {
    let showAddInputs = false;
    // console.log("hello",val)

    if (
      this.state.projectNotif &&
      this.state.projectNotif.length > 0 &&
      val &&
      val.length > 0 &&
      val.includes('status')
    ) {
      showAddInputs = true;
    }

    let fields = field.map((f) => ({
      name: f.children,
      key: f.key,
      id: f.value,
    }));

    this.setState({
      showAddInputs,
      fieldsFilter: fields,
      fieldsFilterValues: val,
    });
  };

  onSearch = (val) => {
    const { channel_type } = queryString.parse(window.location.search);
    if (
      this.props.currentSkill &&
      this.props.currentSkill.metadata &&
      (this.props.currentSkill.metadata.server_type === 'jira_cloud_oauth' ||
        this.props.currentSkill.metadata.server_type === 'jira_cloud')
    ) {
      let query = `query=${val || ''}`;
      const queryType =
        channel_type === 'agent'
          ? '&typeKey=service_desk'
          : '&typeKey=software,business';
      query = query + queryType;
      if (channel_type === 'project' || channel_type === 'agent') {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.props.dropDownSearchJiraProjects(
            this.props.match.params.wId,
            `?query=${query}`
          );
        }, 300);
      }
    }
    //  this.props
  };

  showChannelNotification = () => {
    this.setState({
      showChannelNotification: !this.state.showChannelNotification,
    });
  };

  toggleOffNotif = () => {
    this.setState({ notifStatus: !this.state.notifStatus });
  };

  toggleNotif = () => {
    this.setState({ notifStatus: !this.state.notifStatus });
  };

  toggleJql = () => {
    this.setState({ jqlstatus: !this.state.jqlstatus });
  };

  onChangeJql = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onChangeProject = (event, value) => {
    this.setState({
      projectNotif: event,
      selectedProjectName: value.props.children,
    });
  };

  //frequency
  onChangeFrequency = (event, value) => {
    this.setState({
      channelNotifFreq: event,
    });
    if (value != 0) {
      this.setState({
        startThreadSync: false,
      });
    }

    //Get the text of the input
    // const index = e.nativeEvent.target.selectedIndex;
    // const text = e.nativeEvent.target[index].text;
  };

  //On setting Events
  onChangeEvent = (e) => {
    if (this.state.notifEvent) {
      let arr = this.state.notifEvent;
      let fieldsFilterValues = this.state.fieldsFilterValues;
      let index = arr.findIndex((item) => item === e.target.value);
      if (index > -1) {
        arr.splice(index, 1);
      } else {
        arr.push(e.target.value);
      }
      let showAddInputs =
        this.state.projectNotif &&
        this.state.projectNotif.length > 0 &&
        arr.includes('jira:issue_updated') &&
        (!fieldsFilterValues ||
          fieldsFilterValues.length === 0 ||
          fieldsFilterValues.includes('status'))
          ? true
          : false;

      this.setState({ [e.target.name]: arr, showAddInputs });
    }
  };

  onEventChange = (event, value) => {
    let showAddInputs = false;
    // (this.state.projectNotif&&this.state.projectNotif.length>0&&!value.includes("issue_transitioned"))?true:false
    if (
      event &&
      event.length > 0 &&
      event.includes('jira:issue_updated') &&
      this.state.projectNotif &&
      this.state.projectNotif.length > 0
    ) {
      if (
        !this.state.fieldsFilterValues ||
        this.state.fieldsFilterValues.length === 0 ||
        this.state.fieldsFilterValues.includes('status')
      ) {
        showAddInputs = true;
      }
    }

    this.setState({ showAddInputs, selectedEvents: event });
  };

  getDefaultEvents = () => {
    // Compare all notif events with the ones in state
    let temp = notifEvent.filter(
      (event) => this.state.notifEvent.includes(event.value) && event
    );
    return temp.filter((event) => event);
  };

  //On Changing Frequency
  //  onChangeFrequency = (e) => {
  //  	 this.setState({[e.target.name]: e.target.value});
  //  }

  openEditState = () => {
    this.setState({ edit: !this.state.edit });
  };

  onSave = () => {
    this.setState({
      isSubscriptionSaveButtonDisabled: true,
    });
    try {
      let inputs = this.state.addInputs;
      if (inputs && inputs.length > 0) {
        let lastInput = inputs[inputs.length - 1];
        if (!(lastInput && lastInput.from && lastInput.to)) {
          inputs.pop();
        }
      }
      if (this.props.configureId) {
        let findProject = this.props.jiraChannelConfigs.find(
          (config) => config.project_id[0] == this.state.projectNotif
        );
        if (findProject && findProject._id !== this.props.configureId) {
          throw 'project_already_configured';
        }
      }
      let selectedEvents = this.state.selectedEvents;
      // if (!selectedEvents.length) {
      //   selectedEvents = this.state.notifEvent;
      // }
      if (this.state.selectedEvents.length === 0) {
        message.error('Please select event');
        return;
      }
      this.setState({ loading: true });
      let data = {
        channel_id: this.props.channelId,
        project_id: this.state.projectNotif,
        project_name: this.state.selectedProjectName,
        channelName: this.props.channel_name,
        event_type: selectedEvents,
        fieldsFilter: this.state.selectedEvents.find(
          (e) => e === 'jira:issue_updated'
        )
          ? this.state.fieldsFilter
          : [],
        status: true,
        jqlQuery: this.state.jql,
        frequency:this.state.channelNotifFreq,
        is_bot_channel: false,
        skill_id: this.props.match.params.skill_id,
        jiratransitions: inputs,
        configureId: this.props.configureId,
        sendAsThreadedMessage: this.state.sendAsThreadedMessage,
        startThreadSync: this.state.startThreadSync,
      };
      data.created_by = localStorage.trooprUserId;
      data.workspace_id = this.props.match.params.wId;
      data.channel_type = this.state.parsedQueryString.channel_type;
      // console.log("---data",data)
      if (data.channel_id && data.status && localStorage.trooprUserId) {
        this.setState({});
        this.props
          .setJiraNotifConfig(
            this.props.match.params.wId,
            this.props.match.params.skill_id,
            data,
            this.props.isGridSharedChannel
          )
          .then((res) => {
            //   console.log("res========??????",res);
            if (res.data.success) {
              this.props.getAllJiraConfigs(
                this.props.match.params.wId,
                this.props.match.params.skill_id,
                data.channel_id,
                this.props.isGridSharedChannel
              );
              this.setState({
                jql: res.data.data.jqlQuery,
                selectedProjectName: res.data.data.project_name,
                projectNotif: res.data.data.project_id,
                notifEvent: res.data.data.event_type,
                frequency: res.data.data.frequency,
                notifStatus: res.data.data.status,
                edit: false,
                error: {},
              });
              this.setState({
                loading: false,
                isSubscriptionSaveButtonDisabled: false,
              });
              // this.props.closeModal();
              let url = `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}/${this.props.match.params.sub_skill}?view=channel_preferences&channel_name=${data.channelName}&channel_id=${data.channel_id}&channel_type=${this.state.parsedQueryString.channel_type}&subscription=${res.data.data._id}`;
              this.props.history.push(url);
              message.success('Saved successfully');
            } else if (
              res.data.message === 'JQL not valid' ||
              res.data.message ===
                'Error updating channel notification config: err[object Object]'
            ) {
              // console.log("jql",res.data.message)
              this.setState({
                loading: false,
                isSubscriptionSaveButtonDisabled: false,
              });
              message.error('Enter a valid JQL');
            } else if (res.data.message === 'Please select project') {
              // console.log("project")
              this.setState({
                loading: false,
                isSubscriptionSaveButtonDisabled: false,
              });
              message.error('Please select project');
            } else if (res.data.message === 'No event selected') {
              // console.log("event")
              this.setState({
                loading: false,
                isSubscriptionSaveButtonDisabled: false,
              });
              message.error('Please select event');
            } else {
              message.error(res.data.message, 5);
              this.setState({
                loading: false,
                isSubscriptionSaveButtonDisabled: false,
              });
            }
          });
      }
    } catch (error) {
      this.setState({
        isSubscriptionSaveButtonDisabled: false,
      });
      //  console.log(error);
      if (error == 'project_already_configured') {
        message.error(
          `${this.state.selectedProjectName} Project already subscribed for notifications.To edit click on Events from ${this.state.selectedProjectName}.`
        );
      }
      // console.error(error);
    }
  };

  goBack = () => {
    let url = `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}/${this.props.match.params.sub_skill}?view=channel_preferences&channel_name=${this.props.channel_name}&channel_id=${this.props.channelId}&channel_type=${this.state.parsedQueryString.channel_type}`;

    this.props.history.push(url);
  };
  handleChange = (event, value) => {
    //  console.log("value",value.children)
    let fieldsFilterValues = this.state.fieldsFilterValues;
    let showAddInputs =
      this.state.projectNotif &&
      this.state.projectNotif.length > 0 &&
      event &&
      event.length > 0 &&
      this.state.notifEvent.includes('jira:issue_updated') &&
      (!fieldsFilterValues ||
        fieldsFilterValues.length === 0 ||
        fieldsFilterValues.includes('status'))
        ? true
        : false;

    this.setState({
      projectNotif: event,
      selectedProjectName: value.children,
      showAddInputs,
      addInputs: [],
    });
    this.props.getJiraProjectStatues(
      this.props.match.params.wId,
      this.props.match.params.skill_id,
      event
    );
  };

  threadedMessagesChangeHandler = (e) => {
    let newStatus = e === 'true';
    this.setState({
      sendAsThreadedMessage: newStatus,
    });
  };

  threadSyncStatusChangeHandler = (e) => {
    let newStatus = e === 'true';

    this.setState({
      startThreadSync: newStatus,
    });
  };

  deleteNotificationConfirmation = () => {
    Modal.confirm({
      title: `Are you sure you want to delete this notification subscription?`,
      icon: <ExclamationCircleFilled />,
      content:
        'Deleting this notification subscription will stop sending issue updates to this channel. Corresponding issue update threads will stop syncing with Jira.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      maskClosable: true,
      onOk: () => this.onDelete(),
      onCancel: () => {},
    });
  };

  onDelete = () => {
    const channelId = this.props.channelId;
    const { jiraNotifConfig } = this.props;
    let data = {
      id: this.props.jiraNotifConfig.project_id[0],
      project_name: jiraNotifConfig.project_name[0],
      channelName: this.props.channel_name,
    };
    this.props
      .deleteJiraConfig(
        this.props.match.params.wId,
        this.props.match.params.skill_id,
        channelId,
        data,
        this.props.isGridSharedChannel
      )
      .then((data) => {
        message.success('Deleted successfully');

        let url = `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}/${this.props.match.params.sub_skill}?view=channel_preferences&channel_name=${this.props.channel_name}&channel_id=${this.props.channelId}&channel_type=${this.state.parsedQueryString.channel_type}`;

        this.props.history.push(url);
      });
  };
  onChangeInput = (value, index, type) => {
    // console.log(value,index,type);

    let addedInputs = this.state.addInputs;
    let changedInput = addedInputs[index];
    if (changedInput) {
      changedInput[type] = value;
      changedInput.index = index;
      addedInputs[index] = changedInput;
    } else {
      addedInputs.push({ [type]: value, index });
    }
    this.setState({ addInputs: addedInputs });
  };
  addInputs = () => {
    let addedInputs = this.state.addInputs;
    let lastInput = addedInputs[addedInputs.length - 1];
    if (lastInput && lastInput.from && lastInput.to) {
      addedInputs.push({ index: '' });
      this.setState({ addInputs: addedInputs });
    } else {
      message.error("Please select both 'From' and 'To' columns");
    }
  };
  deleteInputs(id) {
    let filterInputs = this.state.addInputs.filter(
      (input) => input.index !== id
    );
    // console.log(id,filterInputs);

    this.setState({ addInputs: filterInputs });
  }
  isDisabled = () => {
    if (this.state.channelNotifFreq !== 0) {
      this.setState({ startThreadSync: false });
    }
  };

  render() {
    const { channel_type } = queryString.parse(window.location.search);
    let addedInputs =
      this.state.addInputs && this.state.addInputs.length > 0
        ? this.state.addInputs
        : [{ from: undefined, id: '', to: undefined }];
    // const inputChildren= addedInputs.map((val, indx) => {

    //   return (
    //     <div className="proj-setting-common-pointer">
    //       <Row type="flex" justify="space-around" align="middle">
    //         <Col span={10}>
    //           <Select
    //             style={{ width: 280, marginBottom: "10px", marginRight: "5px" }}
    //             placeholder="Select Transition"
    //             value={val.from}
    //             onChange={(e)=>{this.onChangeInput(e,indx,"from")}}
    //           >
    //             <Option value="any">Any</Option>
    //              {this.props.statuses.map(status=>{
    //             return <Option value={status.id}>{status.name}</Option>
    //           })}
    //           </Select>
    //         </Col>
    //         <Col span={2}>
    //           <div style={{ marginTop: "-10px", marginLeft: "24px" }}>
    //             {/* <i className="material-icons">arrow_right_alt</i> */}
    //             <ArrowRightOutlined />
    //           </div>
    //         </Col>
    //         <Col span={10}>
    //           <Select
    //             style={{ width: 280, marginBottom: "10px", marginLeft: "5px" }}
    //             value={val.to}
    //             placeholder="Select Transition"
    //             onChange={(e)=>{this.onChangeInput(e,indx,"to")}}
    //           >
    //          {this.props.statuses.map(status=>{
    //             return <Option value={status.id}>{status.name}</Option>
    //           })}
    //           </Select>
    //         </Col>
    //         <Col span={2}>
    //           {(val.from&&val.to) && (
    //             <div
    //               style={{
    //                 marginTop: "-9px",
    //                 cursor: "pointer",
    //                 marginLeft: "10px"
    //               }}
    //               onClick={()=>this.deleteInputs(val.index)}
    //             >
    //               <DeleteOutlined style={{ marginLeft:"10px",fontSize: "22px", color: "red" }} />
    //             </div>
    //           )}
    //         </Col>
    //       </Row>
    //     </div>
    //   );
    // });

    const inputChildren = addedInputs.map((val, indx) => {
      return (
        <div className='proj-setting-common-pointer'>
          <Row
            style={{
              marginBottom: 8,
              backgroundColor:
                localStorage.getItem('theme') == 'default' ? '#eee' : '',
              padding: 4,
            }}
          >
            <Col span={12} style={{ padding: 2 }}>
              <Text style={{ padding: 2 }}>From Status </Text>
              <Select
                style={{ width: 280, marginBottom: '10px', marginRight: '5px' }}
                placeholder='Select Transition'
                value={val.from}
                onChange={(e) => {
                  this.onChangeInput(e, indx, 'from');
                }}
              >
                <Option value='any'>Any</Option>
                {this.props.statuses.map((status) => {
                  return <Option value={status.id}>{status.name}</Option>;
                })}
              </Select>

              {val.from && val.to && (
                <Button
                  size='small'
                  type='text'
                  danger
                  onClick={() => this.deleteInputs(val.index)}
                >
                  Delete
                </Button>
              )}
            </Col>
            <Col span={12} style={{ padding: 2 }}>
              <Text style={{ padding: 2 }}>To Status</Text>
              <Select
                style={{ width: 280, marginBottom: '10px', marginLeft: '5px' }}
                value={val.to}
                placeholder='Select Transition'
                onChange={(e) => {
                  this.onChangeInput(e, indx, 'to');
                }}
              >
                {this.props.statuses.map((status) => {
                  return <Option value={status.id}>{status.name}</Option>;
                })}
              </Select>
            </Col>
          </Row>
        </div>
      );
    });

    let currentConfiguredProjects =
      this.props.jiraChannelConfigs &&
      this.props.jiraChannelConfigs.map((config) => {
        return config.project_id && config.project_id[0];
      });
    currentConfiguredProjects = currentConfiguredProjects.filter(
      (project_id) => project_id
    );
    // Don't show already configured projects
    let children = (
      channel_type === 'agent'
        ? this.props.projects.filter(
            (proj) => proj.projectTypeKey === 'service_desk'
          )
        : this.props.projects.filter(
            (proj) =>
              proj.projectTypeKey === 'software' ||
              proj.projectTypeKey === 'business'
          )
    ).map((d) => {
      if (currentConfiguredProjects.includes(d.id)) {
        return false;
      }
      return (
        <Option key={d.key} value={d.id} name={d.name}>
          {d.name + ` (${d.key})`}
        </Option>
      );
    });
    children = children.filter((child) => child);
    let textStatus = this.state.notifStatus ? 'Enabled' : 'Disabled';
    let buttonStatus = this.state.notifStatus ? 'Disable' : 'Enable';
    let notificationTitle = `Notification Subscription(${textStatus})`;
    const toolTipEmoji = <QuestionCircleOutlined />;
    return (
      <Fragment>
        {this.state.showloader ? (
          <div style={{ textAlign: 'center', borderRadius: '4px' }}>
            <Spin />
          </div>
        ) : (
          <div>
            <div>
              {/*------------------------------Project-----------------------------------*/}
              <Title level={5}>Deliver updates from these issues only</Title>
              <div
                className='d-flex justify-content-between'
                style={{ marginBottom: '18px' }}
              >
                <Text>From Project</Text>
                <Select
                  autoClearSearchValue
                  //   disabled={!this.state.notifStatus}
                  // mode="multiple"
                  style={{ width: '75%' }}
                  value={this.state.selectedProjectName}
                  onChange={this.handleChange}
                  placeholder='Select project'
                  // tokenSeparators={[","]}
                  onSearch={this.onSearch}
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {children}
                </Select>
              </div>

              {/*------------------------------JQL-----------------------------------*/}
              <div className='d-flex justify-content-between'>
                <Text type='secondary'>JQL Filter (optional)</Text>
                {/* <Text type="secondary"> project="PRJ"</Text> */}
                <TextArea
                  //   disabled={!this.state.notifStatus}
                  autoComplete='off'
                  style={{ width: '75%', fontSize: '14px' }}
                  //className={'form-control ts_custom_input'}
                  name='jql'
                  placeholder='Enter JQL'
                  onChange={this.onChangeJql}
                  value={this.state.jql}
                  autoSize={{ minRows: 2 }}
                />
              </div>
            </div>
            <Divider />

            {/*------------------------------Event Type------------------------------*/}
            <div>
              <Title level={5}>Deliver these updates only</Title>

              <div
                className={
                  'd-flex justify-content-between ' +
                  (this.state.notifStatus ? '' : 'Preference_disable_state',
                  'bottom_space_forms')
                }
                style={{ marginBottom: 16 }}
              >
                <Text>Send when</Text>
                <Select
                  disabled={
                    !(
                      this.state.projectNotif &&
                      this.state.projectNotif.length > 0
                    )
                  }
                  mode='multiple'
                  style={{ width: '75%' }}
                  placeholder='Please select'
                  defaultValue={
                    this.state.notifEvent &&
                    this.getDefaultEvents().map((event) => event.value)
                  }
                  // maxTagCount="responsive"
                  onChange={this.onEventChange}
                >
                  {notifEvent &&
                    notifEvent.map((event, index) => {
                      return (
                        <Option key={event.value} value={event.value}>
                          {event.label}
                        </Option>
                      );
                    })}
                </Select>
              </div>
              {/* {console.log(this.state.notifEvent)} */}
              {this.state.selectedEvents.find(
                (e) => e === 'jira:issue_updated'
              ) && (
                <div
                  style={{ marginBottom: 16 }}
                  className='d-flex justify-content-between'
                >
                  <Text type='secondary'>Select fields (optional)</Text>

                  <Select
                    // disabled={!this.state.status}
                    disabled={
                      !(
                        this.state.projectNotif &&
                        this.state.projectNotif.length > 0
                      )
                    }
                    name='fieldsFilter'
                    style={{ width: '75%' }}
                    value={this.state.fieldsFilterValues}
                    placeholder='Defaults to all updates. Click to choose.'
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(e, field) => this.onjiraFieldChange(e, field)}
                    mode='multiple'
                  >
                    {this.state.fields
                      .filter(
                        (f) =>
                          f.id !== 'comment' &&
                          f.id !== 'worklog' &&
                          f.id !== 'issuelinks' &&
                          f.id !== 'watches'
                      )
                      .map((event, i) => (
                        <Option key={event.key} value={event.id}>
                          {event.name}
                        </Option>
                      ))}
                  </Select>
                </div>
              )}

              {/*------------------------------Transition Filters------------------------------*/}

              {this.state.showAddInputs && (
                <div>
                  <Collapse
                  // defaultActiveKey={["1"]}
                  >
                    <Panel header='Transition Filters' key='1'>
                      <Alert
                        message="You may want notifications only when issue moves to 'Ready to QA' status, then select 'Any' to 'Ready to QA'. If no transition filters are selected, notification will be sent for every status change"
                        type='info'
                      />

                      <br />
                      {inputChildren}
                      <Button type='default' onClick={this.addInputs}>
                        Add Transition Filter
                      </Button>
                    </Panel>
                  </Collapse>
                </div>
              )}
            </div>
            <Divider />
            {/*------------------------------Frequency------------------------------*/}

{this.props.workspace&&this.props.workspace.is_enterprise&&

            <div style={{ marginBottom: '18px' }}>
              <Title level={5}>Notification Delivery</Title>
              <Row
                justify='space-around'
                style={{
                  marginBottom: 16,
                  paddingTop: 8,
                  paddingBottom: 12,
                }}
              >
                <Col span={12}>
                  <div>
                    <Text>Delivery Frequency </Text>
                    <Tooltip title='You can delay notification delivery. All notifications in the selected time interval will be grouped. Choose realtime to deliver without delay.'>
                      {toolTipEmoji}
                    </Tooltip>
                  </div>

                  <Select
                    // disabled={!this.state.notifStatus}
                    disabled={
                      !(
                        this.state.projectNotif &&
                        this.state.projectNotif.length > 0
                      )
                    }
                    name='projectNotif'
                    style={{ width: '400px' }}
                    value={this.state.channelNotifFreq}
                    placeholder='Select Frequency'
                    onChange={this.onChangeFrequency}
                  >
                    {ChannelFrequency.map((project, index) => (
                      <Option key={project.value} value={project.value}>
                        {project.name}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col span={12}>
                  <Text strong>Start Thread Sync </Text>
                  <Tooltip title='Start or enable notification message thread to continuously sync with the corresponding Jira issue.'>
                    {toolTipEmoji}
                  </Tooltip>
                  <Select
                    disabled={this.state.channelNotifFreq !== 0}
                    style={{ width: '100%' }}
                    placeholder='Please select'
                    defaultValue={this.state.startThreadSync.toString()}
                    onChange={this.threadSyncStatusChangeHandler}
                    value={this.state.startThreadSync ? 'true' : 'false'}
                  >
                    <Option key='true'>Yes</Option>
                    <Option key='false'>No</Option>
                  </Select>
                </Col>
              </Row>
            </div>}
            <div style={{ marginBottom: 16 }}>
              <Divider />

              <div style={{ marginBottom: '18px' }}>
                <Title level={5}>Appearance</Title>
                <div>
                  {' '}
                  <Text>Customize message actions</Text> &nbsp;&nbsp;{' '}
                  <Button
                    type='primary'
                    onClick={() =>
                      this.setState({
                        showIssueCardCustomizationModal: true,
                      })
                    }
                  >
                    Customize
                  </Button>
                  {this.state.showIssueCardCustomizationModal && (
                    <IssueCardCustomizationInfo
                      close={() =>
                        this.setState({
                          showIssueCardCustomizationModal: false,
                        })
                      }
                      customizationIn='notifications'
                      isRealTimeNotification={
                        this.state.channelNotifFreq === 0 ? true : false
                      }
                      open={this.state.showIssueCardCustomizationModal}
                    />
                  )}
                </div>
              </div>

              {/* <div
                className="bottom_space_forms"
                style={{ marginBottom: "18px" }}
              >
                <div className="">
                  <Text type="secondary">JQL filter (optional)</Text>
                </div>
                <Input
                  //   disabled={!this.state.notifStatus}
                  autoComplete="off"
                  style={{ width: "100%", fontSize: "14px" }}
                  className={"form-control ts_custom_input"}
                  name="jql"
                  placeholder="Enter JQL"
                  onChange={this.onChangeJql}
                  value={this.state.jql}
                />
              </div> */}

              <div className='d-flex justify-content-end'>
                {this.props.configureId ? (
                  <Button
                    type='danger'
                    className='btn_114 margin__right__button'
                    onClick={this.deleteNotificationConfirmation}
                  >
                    Delete
                  </Button>
                ) : (
                  <Button
                    type='ghost'
                    className='btn_114 margin__right__button'
                    onClick={() => this.goBack()}
                  >
                    Cancel
                  </Button>
                )}
                <Button
                  type='primary'
                  className='btn_114 margin__right__button'
                  loading={this.state.loading}
                  onClick={this.onSave}
                  disabled={this.state.isSubscriptionSaveButtonDisabled}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  console.info(state)
  return {
    projects: state.skills.projects,
    assistant_skills: state.skills,
    statuses: state.skills.statuses,
    jiraChannelConfigs: state.skills.getJiraConfigs,
    currentSkill: state.skills.currentSkill,
    user_now: state.common_reducer.user,
    jiraNotifConfig: state.skills.jiraNotifConfig,
    workspace:state.skills.workspace

  };
};

export default withRouter(
  connect(mapStateToProps, {
    setJiraNotifConfig,
    getJiraNotifConfig,
    getAllJiraConfigs,
    deleteJiraConfig,
    getJiraProjectStatues,
    dropDownSearchJiraProjects,
  })(JiraChannelNotification)
);
